import { goToMenu } from "./direct.js";
import { deepcopy } from "./utility.js";

export const menuSearchCands = [
  { title: "Edit artboard", config: { first: "layout" }, searchKeys: "artboard width height device ppi screen size" },
  { title: "Manage data", config: { first: "data" }, searchKeys: "data fields" },
  { title: "Manage data transforms", config: { first: "data_transform" }, searchKeys: "data transform filter" },
  { title: "Edit layout", config: { first: "layout", subMenu: "edit" }, searchKeys: "layout row rows column columns split small multiples composition scale transpose split x y" },
  { title: "Edit projection", config: { first: "projection" }, searchKeys: "map projection latitude longitutde scale translate zoom" },
  { title: "Edit mark", config: { first: "mark" }, searchKeys: "mark layer encoding property scale range domain stroke fill shape color size bar line point circle square" },
  { title: "Edit axis", config: { first: "axis" }, searchKeys: "axis grid tick label text label" },
  { title: "Edit legend", config: { first: "legend" }, searchKeys: "legend text label" },
  { title: "Edit annotation", config: { first: "annotation" }, searchKeys: "annotation mark label caption text" },
  { title: "Edit title", config: { first: "title" }, searchKeys: "title subtitle caption text" },
  { title: "Edit interaction", config: { first: "interaction" }, searchKeys: "interaction zoom tooltip context pan" },
]

function searchMatch(ref, key) {
  if (!ref) return false;
  let keys = key.split(" ");
  return keys.map((k) => (ref.includes(k) ? 1 : 0)).reduce((c, a) => a + c, 0);
}

export function menuSearch(value, cands) {
  if (!value || value?.length < 0) return [];
  return cands
    .map((v) => {
      // update search alg if needed;
      let rank = searchMatch(v.searchKeys, value);
      if (rank) {
        let outcome = deepcopy(v);
        outcome.rank = rank;
        function command() { goToMenu(outcome.config); };
        outcome.cmd = command;
        return outcome;
      } else return false;
    })
    .filter((v) => {
      return v;
    })
    .sort((a, b) => {
      return (a.rank - b.rank);
    });
}